<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useMapGetter } from 'dashboard/composables/store';
import BasePaywallModal from 'dashboard/routes/dashboard/settings/components/BasePaywallModal.vue';
import CustomRoleListItem from './CustomRoleTableBody.vue';

const router = useRouter();
const { t } = useI18n();

const dummyCustomRolesData = computed(() => [
  {
    name: t('CUSTOM_ROLE.LIST.EXAMPLES.ALL.NAME'),
    description: t('CUSTOM_ROLE.LIST.EXAMPLES.ALL.DESCRIPTION'),
    permissions: [
      'conversation_manage',
      'conversation_participating_manage',
      'conversation_unassigned_manage',
      'contact_manage',
      'report_manage',
      'knowledge_base_manage',
    ],
  },
  {
    name: t('CUSTOM_ROLE.LIST.EXAMPLES.CONVERSATION.NAME'),
    description: t(
      'CUSTOM_ROLE.LIST.EXAMPLES.CONVERSATION.DESCRIPTION'
    ),
    permissions: [
      'conversation_manage',
      'conversation_participating_manage',
      'conversation_unassigned_manage',
    ],
  },
  {
    name: t('CUSTOM_ROLE.LIST.EXAMPLES.CONTACT.NAME'),
    description: t('CUSTOM_ROLE.LIST.EXAMPLES.CONTACT.DESCRIPTION'),
    permissions: ['contact_manage'],
  },
  {
    name: t('CUSTOM_ROLE.LIST.EXAMPLES.REPORT.NAME'),
    description: t('CUSTOM_ROLE.LIST.EXAMPLES.REPORT.DESCRIPTION'),
    permissions: ['report_manage'],
  },
]);

const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const currentUser = useMapGetter('getCurrentUser');
const currentAccountId = useMapGetter('getCurrentAccountId');

const isSuperAdmin = computed(() => {
  return currentUser.value.type === 'SuperAdmin';
});
const i18nKey = computed(() =>
  isOnChatwootCloud.value ? 'PAYWALL' : 'ENTERPRISE_PAYWALL'
);

const goToBillingSettings = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: currentAccountId.value },
  });
};

const tableHeaders = computed(() => {
  return [
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.NAME'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.DESCRIPTION'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.PERMISSIONS'),
    t('CUSTOM_ROLE.LIST.TABLE_HEADER.ACTIONS'),
  ];
});
</script>

<template>
  <div class="w-full min-h-[12rem] relative">
    <div class="w-full space-y-3 text-sm overflow-x-auto">
      <table class="min-w-full">
        <thead class="opacity-30 dark:opacity-30">
          <tr>
            <th
              v-for="thHeader in tableHeaders"
              :key="thHeader"
              class="py-4 ltr:pr-4 rtl:pl-4 text-start text-heading-3 text-n-slate-12"
            >
              <span class="mb-0">
                {{ thHeader }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="opacity-25 dark:opacity-20">
          <CustomRoleListItem :roles="dummyCustomRolesData" :loading="{}" />
        </tbody>
      </table>
    </div>
    <div
      class="absolute inset-0 flex flex-col items-center justify-center w-full h-full bg-gradient-to-t from-white dark:from-slate-900 to-transparent"
    >
      <BasePaywallModal
        feature-prefix="CUSTOM_ROLE"
        :i18n-key="i18nKey"
        :is-on-chatwoot-cloud="isOnChatwootCloud"
        :is-super-admin="isSuperAdmin"
        @upgrade="goToBillingSettings"
      />
    </div>
  </div>
</template>
